export default { odin: 'odin_roundedregular' };